import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { z } from 'zod';

/** What an OAuth or SSO provider appends to its redirect back to us. */
export const OAuthCallbackSearchSchema = z.object({ code: stringParam, state: stringParam });

/** A referral link's base64 inviter id, carried through login and sign-up. */
export const InvitationSearchSchema = z.object({ invitationCode: stringParam });
